import { func, string } from 'prop-types';
import React from 'react';

import {
  hasSBORole,
  isAccounting,
  isSBO,
} from '../../../layout/Variant/Variant';
import { invoiceShape } from '../../../prop-types';
import { allStatusesEnum as invoiceStatuses } from '../../constants';
import { isInvoiceApprovable } from '../../utils';
import ApproveButton from './UpdateInvoiceStatus/ApproveButton';
import CancelButton from './UpdateInvoiceStatus/CancelButton';
import MoveBackToDraft from './UpdateInvoiceStatus/MoveBackToDraft';
import RejectButton from './UpdateInvoiceStatus/RejectButton';
import RequestCancellation from './UpdateInvoiceStatus/RequestCancellationModal';
import SubmitForReviewButton from './UpdateInvoiceStatus/SubmitForReviewButton';

export default class UpdateInvoiceStatusButton extends React.Component {
  constructor(props) {
    super(props);

    this.isReviewButtonDisabled = this.isReviewButtonDisabled.bind(this);
    this.onRequestCancellation = this.onRequestCancellation.bind(this);
  }

  onRequestCancellation(id, cancellationReason) {
    const { sendCancelInvoiceEmail, toggle } = this.props;
    return sendCancelInvoiceEmail(id, cancellationReason).then(() => {
      if (toggle) {
        toggle();
      }
    });
  }

  isReviewButtonDisabled() {
    return this.props.invoice.bookingEntries.length === 0;
  }

  render() {
    const { invoice, status, onUpdateStatus, className, ...rest } = this.props;
    const commonProps = { id: invoice.id, onUpdateStatus, className };
    const { sendCancelInvoiceEmail, toggle, ...cleanedUpRest } = rest;

    switch (status) {
      case invoiceStatuses.DRAFT.value:
      case invoiceStatuses.CHANGES_REQUESTED.value:
        return (
          (isSBO() || hasSBORole()) && (
            <>
              <span className="mr-2">
                <CancelButton {...commonProps} />
              </span>
              {(isSBO() || hasSBORole()) && (
                <SubmitForReviewButton
                  {...commonProps}
                  {...cleanedUpRest}
                  disabled={this.isReviewButtonDisabled()}
                />
              )}
            </>
          )
        );

      case invoiceStatuses.IN_REVIEW.value:
        return isAccounting() ? (
          <>
            <span className="mr-2">
              <RejectButton {...commonProps} {...cleanedUpRest} />
            </span>
            <ApproveButton
              {...commonProps}
              {...cleanedUpRest}
              disabled={!isInvoiceApprovable(invoice)}
            />
          </>
        ) : (
          <span className="mr-2">
            <MoveBackToDraft {...commonProps} />
          </span>
        );
      case invoiceStatuses.APPROVED.value:
        return isAccounting() ? (
          <>
            {hasSBORole() && (
              <span className="mr-2">
                <RequestCancellation
                  onRequestCancellation={this.onRequestCancellation}
                  className={className}
                  id={invoice.id}
                />
              </span>
            )}
            <span className="mr-2">
              <MoveBackToDraft {...commonProps} />
            </span>
            <SubmitForReviewButton
              {...commonProps}
              {...cleanedUpRest}
              disabled={this.isReviewButtonDisabled()}
              title="Move back to Review"
            />
          </>
        ) : (
          <RequestCancellation
            onRequestCancellation={this.onRequestCancellation}
            className={className}
            id={invoice.id}
          />
        );
      case invoiceStatuses.EXPORTED.value:
        return isAccounting() ? (
          <>
            {hasSBORole() && (
              <span className="mr-2">
                <RequestCancellation
                  onRequestCancellation={this.onRequestCancellation}
                  className={className}
                  id={invoice.id}
                />
              </span>
            )}
            <span className="mr-2">
              <MoveBackToDraft {...commonProps} />
            </span>
          </>
        ) : (
          <RequestCancellation
            onRequestCancellation={this.onRequestCancellation}
            className={className}
            id={invoice.id}
          />
        );
      default:
        return null;
    }
  }
}

UpdateInvoiceStatusButton.propTypes = {
  className: string,
  status: string.isRequired,
  invoice: invoiceShape.isRequired,
  onUpdateStatus: func.isRequired,
  sendCancelInvoiceEmail: func,
  toggle: func,
};

UpdateInvoiceStatusButton.defaultProps = {
  className: '',
  sendCancelInvoiceEmail: undefined,
  toggle: undefined,
};
